import { Directive, EventEmitter, Output, Input } from '@angular/core';

import { WpService } from '../service/wp.service';
import { ModelService } from '../service/model/model.service';
import { ModelResponse } from '../service/model/model.interface';


export class ModelDirective {

  private model: ModelService;
  private loading: boolean = false;

  /** Model endpoint */
   set endpoint(endpoint) {

    this.model = <ModelService>this.wpService.model().endpoint(endpoint);
  }

  /** Model QueryArgs */
   wpArgs;

  /** Model Id, the component will refresh the request on id changes */
   set wpId(id: number) {
    this.get(id, this.wpArgs);
  }

  /** Model response */
   wpResponse = new EventEmitter<ModelResponse>();

  /** Loading state */
   wpLoading = new EventEmitter<boolean>(false);

  constructor(private wpService: WpService) {

  }

  /** Get a model of endpoint type by id */
  get(id, args?) {
    if (!this.loading) {
      this.loading = true;
      this.wpLoading.emit(this.loading);

      this.model.get(id, args).subscribe((res) => {
        this.wpResponse.emit(res);
        this.loading = false;
        this.wpLoading.emit(this.loading);
      });
    }
  }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: '[wpModel]'
}, ] },
];
/** @nocollapse */
static ctorParameters: ({type: any, decorators?: DecoratorInvocation[]}|null)[] = [
{type: WpService, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'endpoint': [{ type: Input, args: ['wpModel', ] },],
'wpArgs': [{ type: Input },],
'wpId': [{ type: Input },],
'wpResponse': [{ type: Output },],
'wpLoading': [{ type: Output },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
